// Perplexity Integration Exports

export { PerplexityResearchClient } from './research-client';

export type {
  ResearchRequest,
  ResearchResponse,
  ResearchSource,
  ResearchMetadata,
  ResearchUsage,
  ResearchParameters,
  SavedResearch,
  PerplexityConfig
} from './types';

import { PerplexityResearchClient } from './research-client';
import type { PerplexityConfig } from './types';

// Convenience factory function
export const createResearchClient = (config?: PerplexityConfig) => 
  new PerplexityResearchClient(config); 